exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".child_page[data-v-e4312d9e]{padding:15px}.data_wrap[data-v-e4312d9e]{padding:20px 0;background-color:#ffffff;border-radius:0 0 10px 10px}.money_icon[data-v-e4312d9e]{width:55px;height:55px;margin-right:15px}.money_data[data-v-e4312d9e]{font-size:28px;margin-top:10px}\n", ""]);

// exports
